import './App.css';
import './services/i18n';
import React from 'react';
import { Provider } from 'react-redux';
import Navigation from './route/navigation';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { persistor, store } from './store/store';
import Sidebar from './components/layout/Sidebar';
import { ROUTE } from './constant/routeConstants';
import { AppProvider } from './context/appProvider';
import { PersistGate } from 'redux-persist/integration/react';

function App() {
  const location = useLocation();

  return (
    <div className="App">
      <AppProvider>
        <ToastContainer />
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <div className="flex h-screen">
              {!(
                location?.pathname === ROUTE?.LOGIN ||
                location?.pathname.includes(ROUTE?.GOOGLE_DOC_VIEW)
              ) && <Sidebar />}

              <div className="flex flex-grow flex-col overflow-hidden" style={{ height: '100vh' }}>
                <div className="flex-grow overflow-y-auto [&::-webkit-scrollbar]:hidden">
                  <Navigation />
                </div>
              </div>
            </div>
          </PersistGate>
        </Provider>
      </AppProvider>
    </div>
  );
}

export default App;
